import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { stringify } from 'qs';
import { map, Observable } from 'rxjs';
import { extractStrapiData } from '../../helpers';
import { StrapiPageResponse, Switchgear } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SwitchgearService {
  private readonly http = inject(HttpClient);

  private readonly url = 'api/switchgears/available';

  listForClient(
    clientDocumentId: string,
    minCurrentRating?: number | null,
    requiredParallels?: number | null,
  ): Observable<Switchgear[]> {
    const queryParams: Record<string, unknown> = {
      fields: [
        'documentId',
        'reference',
        'name',
        'description',
        'currentRating',
        'maxSupportedParallels',
        'width',
        'depth',
        'height',
        'reservedWidth',
        'reservedDepth',
        'requiredHeight',
        'cableShoeDiameter',
      ],
      sort: ['reference:asc'],
      pagination: {
        page: 1,
        pageSize: 100,
      },
      clientId: clientDocumentId,
      ...(minCurrentRating != null
        ? { minCurrentRating: Math.ceil(minCurrentRating) }
        : {}),
      ...(requiredParallels != null
        ? { requiredParallels: Math.ceil(requiredParallels) }
        : {}),
    };

    const params = stringify(queryParams, { encodeValuesOnly: true });

    return this.http
      .get<StrapiPageResponse<Switchgear>>(`${this.url}?${params}`)
      .pipe(map((response) => extractStrapiData(response)));
  }
}
